import gtmCore from 'static/script/app/ui/google-tagmanager-service';
import { logger, Analytics } from 'packages';
import { cache, CACHE_KEYS } from 'tradera-utils/cache';
import actionTypes from './action-types';
import uiActions from '../ui/actions';
import { postWishlistItem } from './api';
import { API_ERRORS } from 'tradera-utils/api';
import { MODAL_TYPES } from 'tradera-state/push-notifications/constants';
import getInitialState from './initial-state';

const RECENTLY_VIEWED_CACHE_TTL = 30 * 24 * 60 * 60 * 1000;

const add = items => ({
    type: actionTypes.ADD,
    payload: items
});

const addRecentlyViewed = item => async (dispatch, getStore) => {
    dispatch({
        type: actionTypes.ADD_RECENTLY_VIEWED,
        payload: item
    });

    const {
        items: { recent }
    } = getStore();

    cache.write(
        CACHE_KEYS.RECENTLY_VIEWED_ITEMS,
        recent,
        RECENTLY_VIEWED_CACHE_TTL
    );
};

const setItemWishList = (itemId, exists) => (dispatch, getState) => {
    const existsInState = getState().items.wishListItemIds.includes(itemId);
    if (existsInState !== exists) {
        dispatch({
            type: actionTypes.WISHLIST,
            payload: { itemId, exists }
        });
    }
};
const addItemsToWishList = itemIds => dispatch => {
    dispatch({
        type: actionTypes.WISHLIST_ADD_RANGE,
        payload: { itemIds }
    });
};

/**
 * Toggle item in wishlist
 *
 * @param {int} itemId
 * @param {boolean} [value] - Force add or remove from wishlist
 * @param {boolean} [shouldNotTrackEventBecauseNeedsToBeSameAsLegacyVip]
 * @returns {function(*, *): Promise<* | Error>}
 */
const wishlist = (
    itemId,
    value,
    shouldNotTrackEventBecauseNeedsToBeSameAsLegacyVip = false
) => async (dispatch, getStore) => {
    const {
        member: { isLoggedIn, memberId },
        items: { wishListItemIds },
        page
    } = getStore();
    let existsInWishList;
    if (value === undefined) {
        existsInWishList = wishListItemIds.includes(itemId);
    } else {
        existsInWishList = !value;
    }

    const redirectUrl = window.location.toString();
    const onSignedOutError = () => dispatch(uiActions.signIn({ redirectUrl }));
    if (!isLoggedIn) {
        onSignedOutError();
        return;
    }

    dispatch(setItemWishList(itemId, !existsInWishList));

    if (!existsInWishList) {
        gtmCore.trackGtmEvent('add-to-wishlist', {
            memberId: memberId,
            itemId: itemId
        });
    }
    if (!shouldNotTrackEventBecauseNeedsToBeSameAsLegacyVip) {
        Analytics.trackEvent({
            category: 'Wish list',
            action: existsInWishList ? 'remove' : 'add',
            label: page.type
        });
    }

    return postWishlistItem(itemId, !existsInWishList)
        .then(() => {
            dispatch(
                uiActions.openNotificationOptinModal(
                    MODAL_TYPES.wishlistReminders,
                    'Enable - Wishlist - Reminders (from alert)',
                    'pushModal_wishlist_title',
                    'pushModal_wishlist_description',
                    ['wishlistReminders']
                )
            );
            return !existsInWishList;
        })
        .catch(error => {
            // Restore previous wishlist status on error
            dispatch(setItemWishList(itemId, existsInWishList));
            switch (error.message) {
                case API_ERRORS.LOGGED_OUT:
                    onSignedOutError();
                    break;
                default:
                    break;
            }
            switch (error.message) {
                case API_ERRORS.CANCELLED:
                case API_ERRORS.NETWORK:
                case API_ERRORS.TIMEOUT:
                case API_ERRORS.VERSION_MISMATCH:
                    break;
                default:
                    logger(error);
                    break;
            }
        });
};

const updateItem = ({ itemId, item }) => ({
    type: actionTypes.UPDATE_ITEM,
    payload: { itemId, item }
});

const initialize = initData => ({
    type: actionTypes.INITIALIZE,
    payload: getInitialState(initData)
});

export default {
    add,
    addItemsToWishList,
    addRecentlyViewed,
    initialize,
    setItemWishList,
    updateItem,
    wishlist
};
